import React, {Component} from 'react';
import find from 'lodash/find';
import classNames from 'classnames';

const INITIAL_STATE = {isOpen: false};

export default class SortDropdown extends Component {
	constructor() {
		super();

		this.state = {...INITIAL_STATE};
	}

	componentDidMount = () => {
		window.addEventListener('click', this.onClickWindow);
	}

	componentWillUnmount = () => {
		window.removeEventListener('click', this.onClickWindow);
	}

	onClickWindow = () => {
		if (this.isMouseDownInside) {
			this.isMouseDownInside = false;
			return;
		}

		this.setState({
			isOpen: false
		});

		this.isMouseDownInside = false;
	}

	onMouseDown = () => {
		this.isMouseDownInside = true;
	}

	onClickTrigger = () => {
		this.setState({
			isOpen: !this.state.isOpen,
		});
	}

	onClickOption = value => {
		this.props.onChange(value);

		this.setState({
			isOpen: false,
		});
	}

	render() {
		const {
			value,
			name,
			title = 'Select',
			options = [],
		} = this.props;

		const {
			isOpen,
		} = this.state;

		const selectedOption = value ? find(options, {value}) : null;

		const trigger = (
			<button
				title={title}
				className={classNames('sort-dropdown__trigger', {
					active: isOpen,
				})}
				name={name}
				onClick={this.onClickTrigger}>
				{selectedOption ? (
					<span>
						<span className="color--gray-border">{title}: </span>
						<span className="color--white fw--600">{selectedOption.title}</span>
					</span>
				) : (
					<span>
						<span className="color--gray-border">Select</span>
					</span>
				)}
			</button>
		);

		const optionList = isOpen && (
			<div className="sort-dropdown__option-container">{options.map(option => (
				<button
					title={option.title}
					key={option.value}
					className={classNames('sort-dropdown__option full-width', {
						active: option.value === value,
					})}
					onClick={() => this.onClickOption(option.value)}
					name={option.title}>
					{option.title}
				</button>
			))}</div>
		);

		return (
			<div
				onMouseDown={this.onMouseDown}
				className="pr tl">
				{trigger}
				{optionList}
			</div>
		);
	}
}